import { render, staticRenderFns } from "./TableHistory.vue?vue&type=template&id=6372c253"
import script from "./TableHistory.vue?vue&type=script&lang=js"
export * from "./TableHistory.vue?vue&type=script&lang=js"
import style0 from "./TableHistory.vue?vue&type=style&index=0&id=6372c253&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports